import { Link } from "@tanstack/react-router";
import { type AnchorHTMLAttributes } from "react";
import { useDates } from "../../../dates/DatesContext";
import { generateUrl } from "../../../dates/utils";
import { linkOptionsFromHref } from "../../../utils/searchParams";

interface Props extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> {
  /** App URL, optionally with its own query string; the current date range is added to it. */
  to: string;
}

const TrellisLink = ({ to, children, ...rest }: Props) => {
  const dates = useDates();
  const url = generateUrl(to, dates);

  return (
    <Link {...rest} {...linkOptionsFromHref(url)}>
      {children}
    </Link>
  );
};

export default TrellisLink;
